/** @format */
import { css } from 'styled-components';

import { largeTablet } from '@toucan/client/global/application';

export const styles = css`
    /*
     * One single-cell grid, which every card places itself into (each card
     * sets its own grid-area in fan-card.styles.ts). Stacking them all in one
     * cell is what lets the whole hand occupy a single point on the axis; the
     * splay itself comes from each card's rotation, not from this grid.
     */
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    list-style: none;
    margin: 0;
    padding: 0;

    /*
     * Rotated cards extend well outside this element's own box. Without this
     * the hand would clip its own fan at exactly the box it is meant to
     * escape.
     */
    overflow: visible;

    /*
     * Below large tablet there is no fan left to hold: the cards give up the
     * shared cell (fan-card.styles.ts) and this becomes an ordinary vertical
     * list.
     */
    ${largeTablet(css`
        grid-template-rows: none;
        grid-auto-flow: row;
        gap: var(--layout-spacing-16);
    `)}
`;
